import { AsyncObservable } from "@modules/asyncObservable/asyncObservable"
import { type Service } from "@modules/core/services/serviceType"
import { type Objective, type ObjectiveDraft } from "@modules/objectives/objectivesTypes"
import { ObjectivesApi } from "@modules/objectives/services/objectivesApi"

export class ObjectivesService implements Service {
  constructor(private api: ObjectivesApi) {}
  objectivePrimary = new AsyncObservable<Objective | undefined>(() => this.getObjectivesPrimary())

  init(): Promise<void> {
    return Promise.resolve()
  }

  getObjectivesPrimary() {
    return this.api.getObjectivePrimary()
  }

  async createNewObjective(objective: ObjectiveDraft) {
    return await this.api.createNewObjective(objective)
  }

  async updateOjective(objective: ObjectiveDraft) {
    return await this.api.updateObjective(objective)
  }

  async deleteObjective(id: string) {
    await this.api.deleteObjective(id)
  }
}
